/* eslint-disable no-console */
import type { ProblemJSEnvironmentConfig } from '..';

let fontsLoadedPromise: Promise<void>;

const getFontSource = (filename: string, fontUrl: string): string =>
  `local('Roboto-GMM'), url('${fontUrl}/${filename}.woff2') format('woff2'), url('${fontUrl}/${filename}.woff') format('woff'), url('${fontUrl}/${filename}.ttf') format('truetype')`;

export const loadFonts = async function (
  config: ProblemJSEnvironmentConfig,
  onError: (message: string, err: Error) => void = console.warn
): Promise<void> {
  if (fontsLoadedPromise) return fontsLoadedPromise;

  if (!config.FONT_URL && !config.ROBOTO_GMM) {
    onError('Font URL is not defined', new Error('Font URL is not defined'));

    return Promise.resolve();
  }

  const fontUrl = config.FONT_URL
    ? config.FONT_URL
    : `https://${config.ROBOTO_GMM}`;

  // Font information
  const fontRegular = new FontFace(
    'Roboto-GMM',
    getFontSource('Roboto-GMM-Regular', fontUrl)
  );
  const fontBold = new FontFace(
    'Roboto-GMM',
    getFontSource('Roboto-GMM-Bold', fontUrl),
    { weight: 'bold' }
  );

  fontsLoadedPromise = Promise.all([fontBold.load(), fontRegular.load()])
    .then(function (fonts) {
      console.log('Font was loaded.');

      if (document.fonts) {
        for (let i = 0; i < fonts.length; i++) {
          document.fonts.add(fonts[i]);
        }
      }
    })
    .catch(function (reason) {
      onError(`Unable to load Roboto-GMM from ${fontUrl}`, new Error(reason));
    });

  return fontsLoadedPromise;
};
